


























import Vue from 'vue'
import Component from 'vue-class-component'
import ModalV2 from '@/components/modals/ModalV2.vue'
import Password from '@/components/inputs/Password.vue'
import Input from '@/components/inputs/Input.vue'
import { IFacility, FacilityCCOption } from '@zunta/configurations'
import { getToggle } from '@/utils/facility/facilityPayment/toggle-cc-options'
import Api from '@/api'
import Icon from '@/components/Icon.vue'
@Component({
  props: {
    facility: {
      type: Object
    },
    toggle: {
      type: String
    }
  },
  components: {
    ModalV2,
    Password,
    Input,
    Icon
  }
})

export default class CCToggleOptionsModal extends Vue {
  facility: IFacility = this.$props.facility
  toggle: FacilityCCOption = this.$props.toggle
  password: string = ''
  email: string = ''
  isLoading: boolean = false
  error: boolean = false
  async doToggle () {
    if (!this.email.length || !this.password.length) {
      this.error = true
      return
    }
    if (this.error) this.error = false
    this.isLoading = true
    const response = await Api.facility.ccOptionsToggle({
      email: this.email,
      facilityId: this.facility.id as number,
      type: this.toggle,
      toggle: getToggle(this.facility, this.toggle),
      password: this.password
    })
    if (response.ok) {
      const updated: IFacility = {
        ...this.facility,
        ...await response.json()
      }
      this.$emit('updateSuccess', updated)
    } else {
      if (response.status === 401) {
        this.$emit(
          'updateFailed',
          'Unauthorized to toggle CC option for this Facility'
        )
      } else {
        this.$emit(
          'updateFailed',
          'Failed to toggle CC option for this Facility'
        )
      }
    }
    this.$emit('close')
    this.isLoading = false
  }
}
